module.exports = __webpack_public_path__ + "img/45.14d6e19d.png";